export const AUTH_DIALOG_OPEN_EVENT = "gunziai:auth-dialog:open";

export const AuthDialogPage = {
    ACCOUNT_INPUT: "account-input",
    PASSWORD: "password",
    VERIFICATION_CODE: "verification-code",
    REGISTER: "register",
} as const;

export type AuthDialogPageValue = (typeof AuthDialogPage)[keyof typeof AuthDialogPage];

export interface AuthDialogOpenOptions {
    initialPage?: AuthDialogPageValue;
    redirect?: string;
}

export function openAuthDialog(options: AuthDialogOpenOptions = {}) {
    if (typeof window === "undefined") return false;

    window.dispatchEvent(
        new CustomEvent<AuthDialogOpenOptions>(AUTH_DIALOG_OPEN_EVENT, {
            detail: options,
        }),
    );

    return true;
}
